import React from 'react';
import { useNavigate } from 'react-router-dom';
import { apiConstants } from '../_constants';
import { isEnglish } from '../_helpers';

export const NoteItem = ({ note, subscriptionStatus }) => {
  const navigate = useNavigate();

  const isNoteEnglish = isEnglish(note?.topic_name);

  return (
    <div className={'topicbox ' + (isNoteEnglish ? 'ltrtext' : 'rtltext')}>
      {!note?.is_paid && <div className='freelabel'>Free</div>}
      <div className='topiccontainer'>
        <img
          src={
            note?.topic_image ? apiConstants.imgUrl + note?.topic_image : '/img/subjectdummy.jpeg'
          }
          className='topiclistimg'
          style={{ alignSelf: 'flex-start' }}
        />
        <div>
          <div className='topiclisthead'>{note?.topic_name}</div>
          <div className='notetitle'>{note?.title}</div>
        </div>
      </div>
      <div className='topicactions'>
        <div className='d-flex gap-2'>
          <div
            className={'takestestbtn ' + (!subscriptionStatus && note?.is_paid ? 'Unavilable' : '')}
            onClick={() => {
              if (subscriptionStatus || !note.is_paid) {
                navigate('/notesingle', { state: { id: note._id, title: note.title } });
              }
            }}
          >
            View
          </div>
        </div>
      </div>
    </div>
  );
};
